import { Button } from "@/components/ui/button";
import { UserPlus, UserCheck } from "lucide-react";
import { useUserFollow } from "@/hooks/useUserFollow";
import { cn } from "@/lib/utils";

interface FollowButtonProps {
  userId: string;
  currentUserId?: string;
  size?: "sm" | "default" | "lg";
  className?: string;
}

export const FollowButton = ({ userId, currentUserId, size = "sm", className }: FollowButtonProps) => {
  const { isFollowing, follow, unfollow, isLoading } = useUserFollow(userId, currentUserId);

  // Don't show follow button for own profile or if not logged in
  if (!currentUserId || currentUserId === userId) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isFollowing) {
      unfollow();
    } else {
      follow();
    }
  };

  return (
    <Button
      variant={isFollowing ? "secondary" : "outline"}
      size={size}
      onClick={handleClick}
      disabled={isLoading}
      className={cn(
        "transition-all",
        isFollowing && "hover:bg-destructive/10 hover:text-destructive hover:border-destructive",
        className
      )}
    >
      {isFollowing ? (
        <>
          <UserCheck className="h-3.5 w-3.5 mr-1" />
          <span className="group-hover:hidden">Following</span>
        </>
      ) : (
        <>
          <UserPlus className="h-3.5 w-3.5 mr-1" />
          Follow
        </>
      )}
    </Button>
  );
};
